import apiClient from './api';

export default {
  /**
   * Get site configuration and global settings
   * @returns {Promise} - Axios promise
   */
  getSiteConfig() {
    return apiClient.get('/config/');
  },
  
  /**
   * Get available filter options (for projects and members)
   * @returns {Promise} - Axios promise
   */
  getFilterOptions() {
    return apiClient.get('/filter-options/');
  },
  
  /**
   * Submit contact form
   * @param {Object} formData - Form data (name, email, message, etc.)
   * @returns {Promise} - Axios promise
   */
  submitContactForm(formData) {
    // Check if we're in development environment and need to mock the response
    const isDev = process.env.NODE_ENV === 'development';
    const mockEnabled = isDev && (!process.env.VUE_APP_DISABLE_MOCK_API);
    
    if (mockEnabled) {
      // Log the form data for debugging during development
      console.log('MOCK API CALL - Contact form submission:', formData);
      
      // Return a mocked successful response after a short delay to simulate network
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            data: {
              success: true,
              message: 'Your message has been sent successfully. (DEVELOPMENT MODE)'
            }
          });
        }, 1000);
      });
    }
    
    // Add headers for CORS and CSRF
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      withCredentials: true // Send cookies/credentials with the request
    };
    
    // Make the API call to the endpoint
    return apiClient.post('/contact-form-submit', formData, config);
  },
  
  /**
   * Get a list of locations (for filtering)
   * @returns {Promise} - Axios promise
   */
  getLocations() {
    return apiClient.get('/locations/');
  },
  
  /**
   * Get testimonials
   * @param {Object} params - Optional params like limit
   * @returns {Promise} - Axios promise
   */
  getTestimonials(params = {}) {
    return apiClient.get('/testimonials/', { params });
  }
}; 